import dayjs from "dayjs";

export enum PAGE_TYPE {
    NORMAL = "NORMAL",
    ARTICLE = "ARTICLE",
}

export type TMeta = {
    title?: string;
    description?: string;
    image?: string;
};

export type TPropsValues = { [key: string]: any | undefined };

export type TComponent = {
    id: string;
    props?: TPropsValues;
};

export type TRootComponent = {
    id: "div";
    props: TPropsValues & {
        children: TComponent[];
    };
};

export interface IPageShortMdl {
    _id: string;
    image?: string;
}

export type TLocalized = {
    url: string;
    meta?: TMeta;
    title?: string;
    description?: string;
    component: TRootComponent;
    published: boolean;
    publishedAt?: dayjs.Dayjs;
    featured?: number;
};

export interface IBasePageMDl extends IPageShortMdl {
    type: PAGE_TYPE;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
}

export interface IPageMdl extends IBasePageMDl {
    localized: {
        fr?: TLocalized;
        en?: TLocalized;
    };
}
